/*
 * @Author: yidan.chen
 * @Date: 2025-03-10 11:06:52
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-03-13 15:01:09
 */
import { commonServerInstance } from '@/utilities/instances'

export interface IWorkOrderList {
  type: 'all' | 'rejected'
  partner_id: string
  customer_id: string
  tracking_number: string
  bill_id: string
  bill_guid: string
  id: string
  invoice_number: string
  time_field: string
  start_time: string
  end_time: string
  bill_status: string
  status: string
  charge_type?: string
  page: number
  per_page: number
}

export const fetchWorkOrderStatus = async () => {
  const response = await commonServerInstance.get('/settle/workorder/status')
  return response?.data?.data
}

export const fetchChargeTypeList = async () => {
  const response = await commonServerInstance.get(
    '/settle/workorder/charge-types'
  )
  return response?.data?.data
}

export const fetchWorkOrderList = async (params: IWorkOrderList) => {
  const response = await commonServerInstance.get('/settle/workorder', {
    params
  })
  return response?.data?.data
}

export const fetchWorkOrderTemplates = async () => {
  const response = await commonServerInstance.get('/settle/workorder/templates')
  return response?.data?.data
}

export const uploadWorkOrder = async ({ file }: { file: File }) => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await commonServerInstance.post(
    '/settle/workorder/upload',
    formData,
    {
      timeout: 0
    }
  )
  return response?.data?.data
}

export const reviewWorkOrder = async (
  params: {
    ids: string
    action: string
  } & Partial<IWorkOrderList>
) => {
  const response = await commonServerInstance.post(
    '/settle/workorder/review',
    params
  )
  return response
}

export const deleteWorkOrder = async (
  params: { ids: string } & Partial<IWorkOrderList>
) => {
  const response = await commonServerInstance.post(
    '/settle/workorder/delete',
    params
  )
  return response
}

export const deleteWorkOrderKA = async (
  params: { ids: string } & Partial<IWorkOrderList>
) => {
  const response = await commonServerInstance.post(
    '/settle/workorder/ka-delete',
    params
  )
  return response
}

export const downloadWorkOrder = async (
  params: { ids: string } & Partial<IWorkOrderList>
) => {
  const response = await commonServerInstance.get(
    '/settle/workorder/download',
    {
      params
    }
  )
  return response?.data?.data
}

export const fetchTimeFieldList = async () => {
  const response = await commonServerInstance.get(
    '/settle/workorder/time-fields'
  )
  return response?.data?.data
}
